<template>
  <div class="app-shell">
    <AppHeader />
    <main class="app-main safe-bottom">
      <RouterView v-slot="{ Component, route }">
        <Transition name="fade" mode="out-in">
          <component
            :is="shouldShowAuthGate(route) ? AuthGate : Component"
            :key="route.fullPath"
          />
        </Transition>
      </RouterView>
    </main>
    <BottomNav />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import { RouterView } from "vue-router";
import AppHeader from "./components/AppHeader.vue";
import AuthGate from "./components/AuthGate.vue";
import BottomNav from "./components/BottomNav.vue";
import { useSessionStore } from "./stores/session";

const session = useSessionStore();

onMounted(() => {
  void session.bootstrap();
});

function shouldShowAuthGate(route: RouteLocationNormalizedLoaded) {
  return route.meta.requiresAuth === true && !session.isAuthenticated;
}
</script>
